import { createContext } from 'react';

export const DataInputContext = createContext<null | number>(null);
